import React from "react";
export const StateResolvedContext = React.createContext({ isStateReady: false });
